module.exports = __webpack_public_path__ + "87be7e25cf52f93a44feea34d21ac08a.png";